module.exports = __webpack_public_path__ + "static/img/img(31).6a1bc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(31).png
// module id = sDpr
// module chunks = 1